import React from 'react';
import { useSelector } from 'react-redux';
import What3words from 'emergency_data/src/components/Location/What3words';
import { RowBox } from 'emergency_data/src/components/Location/styles/common.styles';
import { HistoricLocationsToggle } from 'emergency_data/src/components/LocationList/HistoricLocationsToggle';
import { Box, StyledHR, Text } from '@rsos/components/capstone/base';
import DisclaimerCircle from './DisclaimerCircle';
import LatLong from './LatLong';
import LocationAddress from './LocationAddress';
import LocationTime from './LocationTime';

export const CIVIC_LOCATION = 'CIVIC';
const GEODETIC_LOCATION = 'GEODETIC';
// 'BOTH' is also a possible value

const DataCardLocation = ({
  location = { civic: {}, geodetic: {}, provided_location: '' },
  time,
}) => {
  const {
    civic,
    geodetic: geo,
    provided_location: providedLocation,
  } = location;

  const selectedAlertID = useSelector(state => state.incidents.selectedAlertID);
  const locations = useSelector(
    state => state.incidents.alerts[selectedAlertID]?.location_history,
  );
  const { application } = useSelector(state => state.sinatra.user.currentRole);
  const isCentralStation = application === 'central_station';
  const locationsLength = locations?.length;

  return (
    <Box bg="background">
      <Box px="15px" pt="16px" pb="10px">
        <LocationTime
          timeStamp={time}
          color="states"
          timeAgoTextSize="small"
          timeBoxTextSize="xsmall"
        />
        <RowBox noBg align={'flex-start'}>
          <RowBox br={'5px'} mb="8px" width="100%" isHoverable>
            <LocationAddress isCompact isHoverable civic={civic} />
          </RowBox>
          {!isCentralStation && locationsLength > 1 && (
            <HistoricLocationsToggle
              locations={locations}
              selectedAlertID={selectedAlertID}
            />
          )}
        </RowBox>
        <LatLong
          latitude={geo.latitude}
          longitude={geo.longitude}
          isHoverable
        />
        {locations && <What3words location={locations[0]} isHoverable />}
        <RowBox isCompact mt="8px">
          <Text color="secondaryText" size="xsmall">
            {providedLocation === GEODETIC_LOCATION ? (
              <>
                <DisclaimerCircle /> Estimated Address based on Lat/Long
              </>
            ) : providedLocation === CIVIC_LOCATION ? (
              <>
                <DisclaimerCircle /> Estimated Lat/Long based on Address
              </>
            ) : null}
          </Text>
        </RowBox>
      </Box>
      <StyledHR
        border="none"
        height="1px"
        width="100%"
        backgroundColor="lightLineDivider"
      />
    </Box>
  );
};

export default DataCardLocation;
